export const allCountriesSelector = (state) => state.companies.countries.items;

export const allCitiesSelector = (state) => {
  if (!state.app.countries.items) {return [];}
  return state.app.countries.items.reduce((prev, country) => [...prev, ...country.cities], []);
};

// app selectors
export * from './app';

// bike related selectors
export * from './bike';

// all i18n selectors
export * from './i18';

// all city bikes selectors
export * from './cityBikes';

// all search query selectors
export * from './searchQuery';

// all search results selectors
export * from './searchResults';

// all search results map selectors
export * from './searchResultsMap';

// all transaction related selectors
export * from './transaction';

// all sitemap selectors
export * from './sitemap';

// all static page selectors
export * from './staticPage';

// all static pages selectors
export * from './staticPages';



// WEBPACK FOOTER //
// ./src/selectors/index.js